module.exports = "<h1 class=\"yaraBlue mg-t-15 mg-b-25\">Resumo de Análises</h1>\r\n<app-gc-multiselect (gcsSelected)=\"getApprovalSummaryItems($event)\"></app-gc-multiselect>\r\n<div class=\"row\">\r\n  <article class=\"col-sm-12\">\r\n    <app-summary-table\r\n      [summaryItems]=\"analysisSummaryItems\"\r\n      type=\"analysis\"\r\n    ></app-summary-table>\r\n  </article>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cockpit/component/cockpit/analysis-summary/analysis-summary.component.html
// module id = ./src/app/cockpit/component/cockpit/analysis-summary/analysis-summary.component.html
// module chunks = main